import { render } from "./Viewer3DPage.vue?vue&type=template&id=b15fcb54&scoped=true&ts=true"
import script from "./Viewer3DPage.vue?vue&type=script&lang=ts"
export * from "./Viewer3DPage.vue?vue&type=script&lang=ts"

import "./Viewer3DPage.vue?vue&type=style&index=0&id=b15fcb54&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15fcb54"]])

export default __exports__